
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as errormwD7kY_45BU1_rHGEshIkO6bNB5B0luZiwF4k9TLpjX_45IMeta } from "/app/pages/error.vue?macro=true";
import { default as statusGxyJAiT6T08i4QnaacTYMdHkpZ5UFlYXwaNfFcltlQwMeta } from "/app/pages/status.vue?macro=true";
import { default as returnS0J8FlKZYuKvJdhiu0pBWbsRuGQim7WkObLQkGcpzAUMeta } from "/app/pages/form/return.vue?macro=true";
import { default as contact19XaKn8Ayvu42ITdEL3z9OXf71aqOwE7iqClP3p4KHUMeta } from "/app/pages/form/contact.vue?macro=true";
import { default as sentry_45errorQWx8OSBPSFn3muSUBG2jT9kJioyDtn8Zn8PvlncIFT4Meta } from "/app/pages/sentry-error.vue?macro=true";
import { default as returnIframeewXiGPQzT42WfZxhk9_459553uAPGqkbzBpIAQVFtoUIIMeta } from "/app/pages/form/returnIframe.vue?macro=true";
import { default as shop_45releaseWruaX1O_45zWGy_45obRWVmSgmoriOL_pxU63DMxw7mUg04Meta } from "/app/pages/form/shop-release.vue?macro=true";
import { default as contactIframe7w0E7Ex1fZ2fAF2n528FjlFl5JSahIk2UznUt1plj8YMeta } from "/app/pages/form/contactIframe.vue?macro=true";
import { default as sp81_45feedbackLVCcam2AK6X0GSF7Fhd33_hfWetSiF_45rx1FyTdAhEowMeta } from "/app/pages/form/sp81-feedback.vue?macro=true";
import { default as deposit_45feedbackRNL2upgEpjUH09GZ4U7tfJ948MqgX6GwLjW1Gk2AIqgMeta } from "/app/pages/form/deposit-feedback.vue?macro=true";
import { default as shopReleaseIframexm2sPbilRfagyVuCrxBDDY6VOV07rTQ_7xw_X2spYuYMeta } from "/app/pages/form/shopReleaseIframe.vue?macro=true";
import { default as do_45not_45share_453a7bd3e2360a3d29eea436fcGhzgP48fqJNhHhqDPL9gi4j4GHiDj9YqqXf9Nf7jiT0Meta } from "/app/pages/do-not-share-3a7bd3e2360a3d29eea436fc.vue?macro=true";
export default [
  {
    name: "error",
    path: "/error",
    component: () => import("/app/pages/error.vue")
  },
  {
    name: "status",
    path: "/status",
    meta: statusGxyJAiT6T08i4QnaacTYMdHkpZ5UFlYXwaNfFcltlQwMeta || {},
    component: () => import("/app/pages/status.vue")
  },
  {
    name: "form-return",
    path: "/form/return",
    meta: returnS0J8FlKZYuKvJdhiu0pBWbsRuGQim7WkObLQkGcpzAUMeta || {},
    component: () => import("/app/pages/form/return.vue")
  },
  {
    name: "form-contact",
    path: "/form/contact",
    meta: contact19XaKn8Ayvu42ITdEL3z9OXf71aqOwE7iqClP3p4KHUMeta || {},
    component: () => import("/app/pages/form/contact.vue")
  },
  {
    name: "sentry-error",
    path: "/sentry-error",
    component: () => import("/app/pages/sentry-error.vue")
  },
  {
    name: "form-returnIframe",
    path: "/form/returnIframe",
    meta: returnIframeewXiGPQzT42WfZxhk9_459553uAPGqkbzBpIAQVFtoUIIMeta || {},
    component: () => import("/app/pages/form/returnIframe.vue")
  },
  {
    name: "form-shop-release",
    path: "/form/shop-release",
    meta: shop_45releaseWruaX1O_45zWGy_45obRWVmSgmoriOL_pxU63DMxw7mUg04Meta || {},
    component: () => import("/app/pages/form/shop-release.vue")
  },
  {
    name: "form-contactIframe",
    path: "/form/contactIframe",
    meta: contactIframe7w0E7Ex1fZ2fAF2n528FjlFl5JSahIk2UznUt1plj8YMeta || {},
    component: () => import("/app/pages/form/contactIframe.vue")
  },
  {
    name: "form-sp81-feedback",
    path: "/form/sp81-feedback",
    meta: sp81_45feedbackLVCcam2AK6X0GSF7Fhd33_hfWetSiF_45rx1FyTdAhEowMeta || {},
    component: () => import("/app/pages/form/sp81-feedback.vue")
  },
  {
    name: "form-deposit-feedback",
    path: "/form/deposit-feedback",
    meta: deposit_45feedbackRNL2upgEpjUH09GZ4U7tfJ948MqgX6GwLjW1Gk2AIqgMeta || {},
    component: () => import("/app/pages/form/deposit-feedback.vue")
  },
  {
    name: "form-shopReleaseIframe",
    path: "/form/shopReleaseIframe",
    meta: shopReleaseIframexm2sPbilRfagyVuCrxBDDY6VOV07rTQ_7xw_X2spYuYMeta || {},
    component: () => import("/app/pages/form/shopReleaseIframe.vue")
  },
  {
    name: "do-not-share-3a7bd3e2360a3d29eea436fc",
    path: "/do-not-share-3a7bd3e2360a3d29eea436fc",
    meta: do_45not_45share_453a7bd3e2360a3d29eea436fcGhzgP48fqJNhHhqDPL9gi4j4GHiDj9YqqXf9Nf7jiT0Meta || {},
    component: () => import("/app/pages/do-not-share-3a7bd3e2360a3d29eea436fc.vue")
  }
]